import { useEffect, useState } from "react";
import { MessageCircle } from "lucide-react";
import api from "@/lib/api";

export default function WhatsAppButton() {
  const [num, setNum] = useState("919810012256");
  useEffect(() => {
    api.get("/meta/config").then((r) => r.data?.whatsapp_number && setNum(r.data.whatsapp_number)).catch(()=>{});
  }, []);
  const href = `https://wa.me/${num}?text=${encodeURIComponent("Hi GMS, I would like to talk to an expert.")}`;
  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-button"
      aria-label="Chat on WhatsApp"
      className="hidden md:flex fixed bottom-6 left-6 z-40 w-14 h-14 bg-[#25D366] hover:bg-[#1EBE5D] text-white items-center justify-center rounded-full shadow-lg transition-colors"
    >
      <MessageCircle className="w-6 h-6" strokeWidth={2} />
    </a>
  );
}
